import { weavyAnalytics } from '@/providers/weavy-analytics';
import { posthog } from '@/providers/posthog';
import { TrackTypeEnum, type TrackType } from '@/hooks/useAnalytics';
import type { ApiObject, IdentifyTraits } from '@/types/analytics.types';

export const identify = (userId: string, traits: IdentifyTraits) => {
  posthog.identify(userId, traits);
  void weavyAnalytics.identify();
};

//todo: event names in a dedicated file
export const track = (event: string, data: ApiObject | null, type: TrackType = 'Product') => {
  posthog.capture(event, data);
  if (type === TrackTypeEnum.BI) {
    void weavyAnalytics.track(event, data);
  }
};
